import React from "react";

const FullSchedule = () => {
  const mainSchedule = [
    {
        date: "07.12.2024 (Saturday)",
        day: "DAY 1",
        events: [{
          time: "3.30 PM",
          event: "Udyama 1.0 Inauguration, Tagore Theatre, Vazhuthacaud, Thiruvananthapuram",
      }]
      },
    {
      date: "08.12.2024 (Sunday)",
      day: "DAY 2",
      events: [
        { time: "10.00 – 11.30 am", event: "The Vision - Top 7 Key Elements to Ensure Future-Aligned Technical Education (Panel Discussion)" },
        { time: "11.30 – 11.45 am", event: "Tea Break" },
        { time: "11.45 – 1.15 pm", event: "Key Initiatives to Maximize Industry Academia Collaboration (Panel Discussion)" },
        { time: "1.00 – 2.00 pm", event: "Lunch Break" },
        { time: "2.00 – 3.30 pm", event: "Emerging Cutting-Edge Frontiers of Technology - Impact on Technical Education (Panel Discussion)" },
        { time: "3.30 – 4.00 pm", event: "Tea Break" },
        { time: "4.00 – 5.00 pm", event: "Presentations by Startups" },
      ],
    },
    {
      date: "09.12.2024 (Monday)",
      day: "DAY 3",
      events: [
        { time: "9.30 – 11.00 am", event: "New Age Industries & its Impact on Technical Education & Job Opportunities (Panel Discussion)" },
        { time: "11.00 – 11.30 am", event: "Tea Break" },
        { time: "11.30 – 1.00 pm", event: "Top 5 Policies to Aid Future - Aligned Technical Education Ecosystem (Panel Discussion)" },
        { time: "1.00 – 2.00 pm", event: "Lunch Break" },
        { time: "2.00 – 3.30 pm", event: "Challenges and Best Practices of Institutions in Kerala" },
        { time: "3.30 – 4.00 pm", event: "Tea Break" },
        { time: "4.00 – 5.00 pm", event: "Premier Academic institution visit - Mapping of Best practices - Discussion of Top 7 findings" },
      ],
    },
    {
      date: "10.12.2024 (Tuesday)",
      day: "DAY 4",
      events: [
        { time: "9.30 – 11.00 am", event: "Integration of Kerala’s Traditional Industries into the Technical Education Ecosystem" },
        { time: "11.00 – 11.30 am", event: "Tea Break" },
        { time: "11.30 – 1.00 pm", event: "Core Committee-2 : Discussion on top 15-20 pointers which are to be included on Draft Vision Document" },
        { time: "1.00 – 2.00 pm", event: "Lunch Break" },
        { time: "2.00 – 3.00 pm", event: "Highlights of Premier Academic Institution Visit" },
        { time: "3.00 – 3.30 pm", event: "Tea Break" },
        { time: "3.30 – 4.00 pm", event: "Assembling of guests for Valedictory function " },
        { time: "4.00 – 5.30 pm", event: "IAG Conclave Grand Finale and release of Draft Vision Document ( Future Aligned) for Department of Technical Education, Govt.of Kerala by the Hon. Chief Minister of Kerala" },
      ],
    },
  ];

  const detailedSessions = [
    {
      day: "DAY 2",
      venue: "Mascot Hotel Main Hall",
      sessions: [
        {
          time: "10.00 – 11.30 am",
          topic: "The Vision - Top 7 Key Elements to Ensure Future-Aligned Technical Education",
          speakers: [
            { name: "Mrs. Ishita Roy IAS", designation: "Principal Secretary, Department of Higher Education, Govt. of Kerala" },
            { name: "Dr. Usha Titus IAS", designation: "Chairperson and Managing Director, Additional Skill Acquisition Programme, Kerala" },
            { name: "Prof. V R Desai", designation: "Director, IIT Dharwad" },
            { name: "Dr. Rajasree M S", designation: "Former Vice Chancellor, APJKTU & Former Director of Technical Education" },
            { name: "Dr. Shalij P R", designation: "Director, Department of Technical Education, Govt. of Kerala" },
          ],
          moderator: { name: "Dr. Jayasankar Prasad C", designation: "Director, DCSMAT Institutions" },
          coordinators: [
            { name: "Mr. Kiran C J", designation: "Govt. Engineering College, Barton Hill, TVM" },
            { name: "Ms. Suryapriya S", designation: "Govt. Engineering College, Barton Hill, TVM" },
          ],
          teaBreak: "11.30 – 11.45 am",
        },
        {
          time: "11.45 am – 1.15 pm",
          topic: "Key Initiatives to Maximize Industry Academia Collaboration",
          speakers: [
            { name: "Prof. V R Desai", designation: "Director, IIT Dharwad" },
            { name: "Dr. Jayan Jose Thomas", designation: "Professor, IIT Delhi" },
            { name: "Dr. Krishna Kumar Krishnan", designation: "Professor and Chair, Department of Industrial Systems and Manufacturing Engineering, Wichita, Kansas, USA" },
            { name: "Mr. K Chandran", designation: "MD&CEO, Campus Angels Network & Principal Advisor, SSN Incubation" },
            { name: "Mr. Philip George", designation: "Sr. Manager, HR & Learning, Skilling, Toyota Kirloskar Motor" },
          ],
          moderator: { name: "Mr. Anoop Ambika", designation: "CEO, Kerala State Start-Up Mission" },
          coordinators: [
            { name: "Dr. Jeena R S", designation: "Govt. Engineering College, Barton Hill, TVM" },
            { name: "Ar. Tessy Varkey", designation: "Dept. of Architecture, RIT Kottayam" },
          ],
          lunchBreak: "1.15 – 2.00 pm", // Lunch Break
        },
        {
          time: "2.00 – 3.30 pm",
          topic: "Emerging Cutting-Edge Frontiers of Technology - Impact on Technical Education",
          speakers: [
            { name: "Mr. Biju Dominic", designation: "Chairman, Final Mile Consulting & Chief Evangelist Fractal Analytics" },
            { name: "Dr. Krishna Kumar Krishnan", designation: "Professor and Chair, Department of Industrial Systems and Manufacturing Engineering, Wichita, Kansas, USA" },
            { name: "Prof. Karthik Vaidhyanathan", designation: "Assistant Professor, IIIT Hyderabad" },
            { name: "Latha Chembrakalam", designation: "VP & Head of Technical Center India, Continental India" },
            { name: "Prof. Madhu Ganesh", designation: "Director, Twinning Programs, Karunya Institute of Technology" },
          ],
          moderator: { name: "Shyam Kumar R", designation: "Ex Business Head (S&M) KINTO INDIA (Toyota Global Mobility Brand)" },
          coordinators: [
            { name: "Dr. Thushara V T", designation: "Dept. of Civil Engineering, CET" },
            { name: "Harith", designation: "Dept. of Civil Engineering, CET" },
          ],
          teaBreak: "3.30 – 4.00 pm",
        },
        {
          time: "4.00 – 6.00 pm",
          topic: "Presentations by Startups",
          speakers: [
            { name: "Mr. Ajay Thomas", designation: "Vatsaa Energy Pvt. Ltd." },
            { name: "Mr. Vishal Nair", designation: "Genrobotics Medical and Mobility" },
            { name: "Mr. Atthri Anand", designation: "Deep Flow Technologies" },
            { name: "Ms. Jishma R Jayan", designation: "Geo- Transect LLP" },
          ],
          moderator:[],
          coordinators: [
            { name: "Mr. Pranoy S Raj", designation: "College Of Engineering Trivandrum" },
          ],
        },
      ],
    },
    {
      day: "DAY 3",
      venue: "Venue TBD",
      sessions: [
        {
          time: "9.30 – 11.00 am",
          topic: "New Age Industries & Its Impact on Technical Education & Job Opportunities",
          speakers: [
            { name: "Dr. Madhur Gupta", designation: "Founder & CEO, Quantpro Global Pvt. Ltd." },
            { name: "Mr. Raghavan Muralidharan", designation: "CTO, STED Tata Power" },
            { name: "Mr. G Levin", designation: "CEO, KSPACE" },
            { name: "Mr. Sudhir Nair", designation: "Vice President, Agappe Diagnostics Ltd" },
            { name: "Mr. Sunil Kumar Ayyappan", designation: "General Manager - Projects, Adani Ports" },
            { name: "Mr. Murali L S", designation: "Deputy Chief Consultant - KIIFB" },
          ],
          moderator: { name: "Prof. KRS Krishnan", designation: "Professor, Karunya University" },
          coordinators: [
            { name: "Dr. Anjan Nair", designation: "GEC Thrissur" },
            { name: "Smt. Leena Mary John", designation: "GPTC Nedumangad" },
          ],
          teaBreak: "11.00 – 11.30 am",
        },
        {
          time: "11.30 – 1.00 pm",
          topic: "Top 5 Policies to Aid Future-Aligned Technical Education Ecosystem",
          speakers: [
            { name: "Dr. P V Unnikrishnan", designation: "Member Secretary, K-DISC" },
            { name: "Dr. Jayashanker Prasad", designation: "Director, DCSMAT Institutions" },
            { name: "Mr. K R Jyothilal IAS", designation: "Additional Chief Secretary, Govt. of Kerala" },
            { name: "Dr. KRS Krishnan", designation: "Director of Innovation, Karunya Institute of Technology" },
            { name: "Dr. Arun Surendran", designation: "Principal, Trinity College of Engineering" },
            { name: "Dr. Samson Mathew", designation: " Director NATPAC" },
            { name: "Dr. Kuncheria P Isaac", designation: "Former Vice Chancellor, APJAKTU" },
          ],
          moderator: { name: "Dr. Anil B", designation: "Former Principal, Govt. Engineering College, Barton Hill, TVM" },
          coordinators: [
            { name: "Dr. Jeena R S", designation: "Govt. Engineering College, Barton Hill, TVM" },
            { name: "Ar. Tessy Varkey", designation: "Dept. of Architecture, RIT Kottayam" },
          ],
          lunchBreak: "1.00 – 2.00 pm", // Lunch Break
        },
        {
          time: "2.00 – 3.30 pm",
          topic: "Challenges and Best Practices of Institutions in Kerala",
          speakers: [
            { name: "Dr. Cyriac Mathew", designation: "Former Additional Director of Collegiate Education, Kerala" },
            { name: "Dr. Rajan Varughese", designation: " Member Secretary, Kerala Higher Education Council" },
            { name: "Dr. Vinod Kumar Jacob", designation: "Professor, MACE, Kothamangalam" },
            { name: "Dr. Aiju Thomas ", designation: "Principal, Govt. Polytechnic College,Kalamassery" },
            { name: "Dr. Bharati Raj", designation: "Assistant Professor, NSS College of Engineering, Palakkad" },
            { name: "Dr. Shaji K ", designation: "Associate Professor, GEC Thrissur" },
            { name: "Mr. Jojy Thomas", designation: "Chairman, Gregorian Institute of Technology" },
          ],
          moderator: { name: "Dr. Biju Longhinos", designation: ", Associate Professor in Geology,College of Engineering Trivandrum" },
          coordinators: [
            { name: "Mr. Kiran C J", designation: "Govt. Engineering College Barton Hill" },
            { name: "Ms. Suryapriya S, ", designation: "Govt. Engineering College Barton Hill" },
          ],
          teaBreak: "3.30 – 4.00 pm",
        },
        {
          time: "4.00 – 5.00 pm",
          topic: "Premier Academic institution visit- Mapping of Best practices- Discussion of Top 7 findings",
          speakers: [
            { name: "Mr. Achuthan Nedunghat", designation: " Director- Technical, Presevi Industries Pvt. Ltd" },
            { name: "Dr K V Jayakumar", designation: "Professor, IIT Dharwad" },
            { name: "Dr Ayoob", designation: "Former Pro-Vice Chancellor, APJA KTU" },
          ],
          moderator: { name: "Dr. Binumol Tom RIT, Kottayam \n Dr. P Sooraj - College of Engineering, Kannur Dr. Aiju Thomas", designation: " Principal, Govt. Polytechnic College,Kalamassery " },
          // moderator: { name: "Dr. P Sooraj", designation: "College of Engineering, Kannur" },
          // moderator: { name: "Dr. Aiju Thomas", designation: "Principal, Govt. Polytechnic College,Kalamassery" },
          coordinators: [
            { name: "Dr. Thushara V T", designation: "College of Engineering Trivandrum" },
            { name: "Mr. Harith Suraj", designation: "College of Engineering Trivandrum" },
          ],
        },
      ],
    },
    {
        day: "DAY 4",
        venue: "Venue TBD",
        sessions: [
          // Morning Sessions (same structure as Day 2 & Day 3)
          {
            time: "9.30 – 11.00 am",
            topic: "Integration of Kerala’s Traditional Industries into the Technical Education Ecosystem",
            speakers: [
            { name: "Cluster 1- Kollam Cashew Processors Association Mentoring Institution – Dr. Mohammed Mansoor O", designation: "TKM College of Engg Representative - Dr. Mohammed Mansoor O" },
            { name: "Cluster 2- Perumbavoor Plywood Manufacturers Consortium Pvt. Ltd, Mentoring Institution", designation: "Toc H Institute of Science & Technology, Arakkunnam -  Mr. Titus Thomas" },

            ],
          moderator: { name: "Dr. S Sreekumar", designation: "Former Director Integrated Rural Technology Centre, Palakkad" },
            coordinators: [
            { name: "Mr. Prasoon Mangalath", designation: "" },
            ],
            teaBreak: "11.00 – 11.30 am",
          },
          {
            time: "11.30 – 1.00 pm",
            topic: "Discussion on top 15-20 pointers which are to be included in the Draft Vision Document",
            memberHead: "Core Committee 2 - Members",
            details: [
              { name: "Dr. Suresh K", role: "Principal, CET" },
              { name: "Dr. Prince A", role: "Principal, RIT Kottayam" },
              { name: "Dr. Jasmin E A", role: "Principal, GEC Kozhikkode" },
              { name: "Dr. Meenakshy K", role: "Principal, GEC Thrissur" },
              { name: "Dr. Aiju Thomas", role: "Principal, Govt. Polytechnique College Kalamassery" },
              { name: "Dr. Arun Surendran", role: "Principal, Trinity College, TVM" },
              { name: "Dr. Binumol Tom", role: "Professor, Dept. of Architecture, RIT Kottayam" },
              { name: "Dr. P Sooraj", role: "Professor, Department of Mechanical Engg, GEC Kannur" },
              { name: "Dr. Shiny G", role: "Principal, GEC Barton Hill" },
              { name: "Dr. B Anil,", role: "Former Principal, Govt. Engineering College Barton Hill, Thiruvananthapuram" }
            ],
            lunchBreak: "1.00 – 2.00 pm", // Lunch Break
          },          
          {
            time: "2.00 – 3.00 pm",
            topic: "Highlights of Premier Academic Visits",
            memberHead: "Session Coordinators",
            details: [
              { name: "Dr. Deepu S P", role: "" },
            ],
            teaBreak: "3.00 – 3.30 pm"
          },
          
          {
            time: "3.30 – 4.00 pm",
            topic: "Assembling of guests for Valedictory function ",
            // details: "Official release of the finalized Vision Document by the Hon. Chief Minister.",
          },
          {
            time: "4.00 – 5.00 pm",
            topic: "IAG Conclave Grand Finale and release of Draft Vision Document( Future Aligned) for Department of Technical Education, Govt.of Kerala by the Hon. Chief Minister of Kerala",
            // details: "Official release of the finalized Vision Document by the Hon. Chief Minister.",
          },
        ],
      },
  ];
  
  

  return (
    <div className="container mx-auto p-4 font-custom">
      <h1 className="text-2xl font-bold text-center mb-6">UDYAMA 1.0 Schedule of Events</h1>

      {/* Main Schedule */}
      <div className="overflow-x-auto mb-10">
        <h2 className="text-xl font-bold mb-4">Main Schedule</h2>
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-500 text-white">
              <th className="border border-gray-300 px-4 py-2">Date</th>
              <th className="border border-gray-300 px-4 py-2">Time</th>
              <th className="border border-gray-300 pr-4 py-2">Events</th>
            </tr>
          </thead>
          <tbody>
            {mainSchedule.map((item, index) => (
              <React.Fragment key={index}>
                <tr className="bg-gray-100">
                  <td
                    className="border border-gray-300 px-4 py-2 font-bold"
                    rowSpan={item.events ? item.events.length + 1 : 1}
                  >
                    {item.date}
                  </td>
                  {item.day && (
                    <td className="border border-gray-300 px-4 py-2 font-semibold text-center bg-gray-200" colSpan="2">
                      {item.day}
                    </td>
                  )}
                </tr>
                {item.events &&
                  item.events.map((event, i) => (
                    <tr key={i}>
                      <td className="border border-gray-300 px-4 py-2">{event.time}</td>
                      <td className="border border-gray-300 px-4 py-2">{event.event}</td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Detailed Sessions */}
      <div className="overflow-x-auto">
  {/* DAY 2 & DAY 3 Sessions (As previously discussed) */}
  {detailedSessions.map((dayDetail, index) => (
    dayDetail.day !== "DAY 4" && (
      <div key={index} className="mb-6">
        <h2 className="text-xl font-bold mb-4">{dayDetail.day} - Detailed Sessions</h2>
        <h3 className="font-semibold mb-2">Venue: {dayDetail.venue}</h3>
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-500 text-white">
              <th className="border border-gray-300 px-4 py-2">Time</th>
              <th className="border border-gray-300 px-4 py-2">Topic</th>
              <th className="border border-gray-300 px-4 py-2">Speakers</th>
              <th className="border border-gray-300 px-4 py-2">Moderator</th>
              <th className="border border-gray-300 px-4 py-2">Session Coordinators</th>
            </tr>
          </thead>
          <tbody>
            {dayDetail.sessions.map((session, i) => (
              <React.Fragment key={i}>
                <tr>
                  <td className="border border-gray-300 px-4 py-2">{session.time}</td>
                  <td className="border border-gray-300 px-4 py-2">{session.topic}</td>
                  <td className="border border-gray-300 px-4 py-2 align-middle">
                    {session.speakers.map((speaker, index) => (
                      <div key={index} className="py-1">{speaker.name} - {speaker.designation}</div>
                    ))}
                  </td>
                  {session.moderator &&
                  <td className="border border-gray-300 px-4 py-2 align-middle">{session.moderator.name} - {session.moderator.designation}</td>
                }
                {session.coordinators &&
                  <td className="border border-gray-300 px-4 py-2 align-middle">
                    {session.coordinators.map((coordinator, index) => (
                      <div key={index} className="py-1">{coordinator.name} - {coordinator.designation}</div>
                    ))}
                  </td>
                }
                </tr>
                {session.teaBreak && (
                  <tr>
                    <td colSpan="5" className="border border-gray-300 px-4 py-2 text-center bg-gray-200">
                      <strong>Tea Break</strong> - {session.teaBreak}
                    </td>
                  </tr>
                )}
                {session.lunchBreak && (
                <tr>
                  <td colSpan="5" className="border border-gray-300 px-4 py-2 text-center bg-gray-200">
                    <strong>Lunch Break</strong> - {session.lunchBreak}
                  </td>
                </tr>
              )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    )
  ))}

  {/* Separate Table for Day 4 Morning Sessions */}
  {detailedSessions.map((dayDetail, index) => (
    dayDetail.day === "DAY 4" && (
      <div key={index} className="mb-6">
        <h2 className="text-xl font-bold mb-4">{dayDetail.day} - Detailed Sessions</h2>
        <h3 className="font-semibold mb-2">Venue: {dayDetail.venue}</h3>
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-blue-500 text-white">
              <th className="border border-gray-300 px-4 py-2">Time</th>
              <th className="border border-gray-300 px-4 py-2">Topic</th>
              <th className="border border-gray-300 px-4 py-2">Speakers</th>
              <th className="border border-gray-300 px-4 py-2">Moderator</th>
              <th className="border border-gray-300 px-4 py-2">Session Coordinators</th>
            </tr>
          </thead>
          <tbody>
            {dayDetail.sessions.slice(0, 1).map((session, i) => ( // First session (morning)
              <tr key={i}>
                <td className="border border-gray-300 px-4 py-2">{session.time}</td>
                <td className="border border-gray-300 px-4 py-2">{session.topic}</td>
                <td className="border border-gray-300 px-4 py-2 align-middle">
                  {session.speakers.map((speaker, index) => (
                    <div key={index} className="py-1">{speaker.name} - {speaker.designation}</div>
                  ))}
                </td>
                {session.moderator &&
                <td className="border border-gray-300 px-4 py-2 align-middle">{session.moderator.name} - {session.moderator.designation}</td>
                }
                {session.coordinators &&
                <td className="border border-gray-300 px-4 py-2 align-middle">
                  {session.coordinators.map((coordinator, index) => (
                    <div key={index} className="py-1">{coordinator.name} - {coordinator.designation}</div>
                  ))}
                </td>
                }
              </tr>
            ))}
            
          </tbody>
        </table>
      </div>
    )
  ))}

  {/* Separate Table for Day 4 Afternoon Sessions (Different Format, No Speakers, Moderators) */}
  {detailedSessions.map((dayDetail, index) => (
  dayDetail.day === "DAY 4" && (
    <div key={index} className="mb-6">
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-blue-500 text-white">
            <th className="border border-gray-300 px-4 py-2">Time</th>
            <th className="border border-gray-300 px-4 py-2">Topic</th>
            <th className="border border-gray-300 px-4 py-2">Details</th>
          </tr>
        </thead>
        <tbody>
          {dayDetail.sessions.slice(1).map((session, i) => ( // Afternoon sessions
            <React.Fragment key={i}>
              <tr>
                <td className="border border-gray-300 px-4 py-2">{session.time}</td>
                <td className="border border-gray-300 px-4 py-2">{session.topic}</td>
                <td className="border border-gray-300 px-4 py-2 align-middle">
                <h4 className="text-lg mb-5 text-gray-800"><strong>{session.memberHead}</strong></h4>
                <ul>
                  {session.details?.map((member, index) => (
                    <li key={index}>
                      <strong>{member.name}</strong>, {member.role}
                    </li>
                  ))}
                </ul>
                </td>
              </tr>
              {session.teaBreak && (
                <tr>
                  <td colSpan="3" className="border border-gray-300 px-4 py-2 text-center bg-gray-200">
                    <strong>Tea Break</strong> - {session.teaBreak}
                  </td>
                </tr>
              )}
              {session.lunchBreak && (
                <tr>
                  <td colSpan="3" className="border border-gray-300 px-4 py-2 text-center bg-gray-200">
                    <strong>Lunch Break</strong> - {session.lunchBreak}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          </tbody>
        </table>
      </div>
    )
  ))}
</div>

    </div>
  );
};

export default FullSchedule;